import React, { useState, useEffect } from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import { assetsAPI } from '../lib/api';

export const SparklineChart = ({ assetId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await assetsAPI.getSparkline(assetId);
        const chartData = response.data.data.map((item) => ({
          price: item.price,
        }));
        setData(chartData);
      } catch (error) {
        console.error('Failed to fetch sparkline:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [assetId]);

  if (loading || data.length === 0) {
    return <div className="h-10 bg-[hsl(var(--background-secondary))] rounded animate-pulse" />;
  }

  const firstPrice = data[0]?.price || 0;
  const lastPrice = data[data.length - 1]?.price || 0;
  const isGain = lastPrice >= firstPrice;

  return (
    <div className="h-10 w-full">
      <ResponsiveContainer width="100%" height={40}>
        <LineChart data={data}>
          <Line
            type="monotone"
            dataKey="price"
            stroke={isGain ? 'hsl(142, 70%, 42%)' : 'hsl(0, 72%, 51%)'}
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};